import StepShell from '../StepShell';
import { colors, layout } from '../styles';
import usePreEmploymentDraft from './preEmployment/usePreEmploymentDraft';
import useSaveLaterHandler from './preEmployment/useSaveLaterHandler';
import { BaseStepProps } from './BaseStepProps';

const PreEmploymentReferencesStep = ({
  step,
  stepIndex,
  totalSteps,
  completedSteps,
  token,
  tokenData,
  applicationDraft,
  onBack,
  onPrevious,
  onNext,
  onSaveLater,
}: BaseStepProps) => {
  const { formData, updateForm, saveAsDraft } = usePreEmploymentDraft(token, applicationDraft);
  const { handleSaveLater } = useSaveLaterHandler({
    saveAsDraft: () => saveAsDraft({ token, userId: tokenData.userId, userName: tokenData.userName }),
    onSaveLater,
  });

  return (
    <StepShell
      stepNumber={stepIndex + 1}
      totalSteps={totalSteps}
      completedSteps={completedSteps}
      title={step.title}
      onBack={onBack}
      onPrevious={onPrevious}
      onSaveLater={handleSaveLater}
      onNext={onNext}
      nextLabel="Next"
      nextDisabled={!formData.references}
    >
      <h3 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Professional References</h3>
      <p style={{ color: colors.muted, fontSize: 14, marginTop: 6 }}>
        List up to three professional references. Include name, title, employer, phone number and your relationship.
      </p>

      <div style={{ marginBottom: 16 }}>
        <label style={layout.label}>References *</label>
        <textarea
          rows={10}
          value={formData.references}
          onChange={(e) => updateForm({ references: e.target.value })}
          placeholder="1. Name, title, employer — phone number — relationship&#10;2. Name, title, employer — phone number — relationship&#10;3. Name, title, employer — phone number — relationship"
          style={{ ...layout.input, resize: 'vertical', fontFamily: 'inherit' }}
        />
      </div>
    </StepShell>
  );
};

export default PreEmploymentReferencesStep;
